export default "__VITE_ASSET__DNN_uSGx__"